import React from 'react';

import styles from './GradeRangeSquare.scss';

function GradeRangeSquare({ gradeRange, size }) {
  if (!gradeRange) return null;

  const lower = parseInt(gradeRange.lower, 10);
  const higher = parseInt(gradeRange.higher, 10);
  const sizeClass =
    typeof size !== 'undefined' ? ' GradeRangeSquare--large' : '';
  const isPreK = lower === 0 || lower === -1;

  const singleGrade = lower === higher;
  let gradeClass = `GradeRangeSquare GradeRangeSquare--grade-${lower}`;
  gradeClass += singleGrade ? ' GradeRangeSquare--single' : '';
  let gradeLabel;

  if (isPreK && singleGrade) {
    gradeLabel = (
      <span className="GradeRangeSquare--label">
        <small>Pre-K</small>
        &amp; K
      </span>
    );
    gradeClass = `GradeRangeSquare GradeRangeSquare--grade-${lower}`;
  } else if (lower === 8 && higher >= 9) {
    gradeLabel = <span className="GradeRangeSquare--label">8+</span>;
    gradeClass += ' GradeRangeSquare--single';
  } else if (isPreK && higher >= 8) {
    gradeLabel = <span className="GradeRangeSquare--label">All Grades</span>;
    gradeClass = 'GradeRangeSquare GradeRangeSquare--all';
  } else if (isPreK) {
    gradeLabel = (
      <span className="GradeRangeSquare--label">K&ndash;{higher}</span>
    );
  } else if (singleGrade) {
    gradeLabel = <span className="GradeRangeSquare--label">{lower}</span>;
  } else {
    gradeLabel = (
      <span className="GradeRangeSquare--label">
        {lower}&ndash;
        {higher}
      </span>
    );
  }

  return <div className={gradeClass + sizeClass}>{gradeLabel}</div>;
}

export default GradeRangeSquare;
